import moment from 'moment/moment';
import React, { useState } from 'react';
import { DateTimeInput } from 'semantic-ui-calendar-react-17';
import { Button, Modal } from 'semantic-ui-react';

interface ModalSchedulerGtfsProps {
    gtfs: { gtfsFileId: string, activationDate: Date };
    open: boolean;
    okButtonHandler: (date: Date) => void
    cancelButtonHandler: () => void;
}

export const ModalSchedulerGtfs: React.FC<ModalSchedulerGtfsProps> = (props) => {
    const [dateTimeState, setDateTimeState] = useState<Date>();

    const onUpdateActivationDate = (value: Date) => {
        props.gtfs.activationDate = value;
        setDateTimeState(value);
    };

    return (
        <Modal dimmer={'inverted'}
               open={props.open}>
            <Modal.Header>Publishing the GTFS file will be scheduled.</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <DateTimeInput
                        name="dateTime"
                        fluid
                        dateFormat="YYYY-MM-DD"
                        timeFormat="AMPM"
                        value={props.gtfs?.activationDate ? moment.parseZone(props.gtfs?.activationDate).format('YYYY-MM-DD h:mm A') : ''}
                        minDate={moment(new Date().setHours(0, 0, 0, 0)).add(-1, 'days').format('YYYY-MM-DD')}
                        iconPosition="left"
                        popupPosition="bottom center"
                        closable={true}
                        animation="fade"
                        onChange={(_, { value }) => onUpdateActivationDate(value)}
                        style={{ width: '190px' }}
                    />
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.cancelButtonHandler}>Cancel</Button>
                <Button onClick={() => {
                    if (dateTimeState) {
                        props.okButtonHandler(dateTimeState);
                    }
                }}>OK</Button>
            </Modal.Actions>
        </Modal>
    );
};